var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#E22121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.52538 4.493V7.067C8.52538 7.34 8.51188 7.6085 8.48488 7.8725C8.45788 8.1335 8.42338 8.411 8.38138 8.705H7.62538C7.58338 8.411 7.54888 8.1335 7.52188 7.8725C7.49488 7.6085 7.48138 7.34 7.48138 7.067V4.493H8.52538ZM7.30588 10.388C7.30588 10.295 7.32238 10.2065 7.35538 10.1225C7.39138 10.0385 7.43938 9.9665 7.49938 9.9065C7.56238 9.8465 7.63588 9.7985 7.71988 9.7625C7.80388 9.7265 7.89388 9.7085 7.98988 9.7085C8.08288 9.7085 8.17138 9.7265 8.25538 9.7625C8.33938 9.7985 8.41138 9.8465 8.47138 9.9065C8.53438 9.9665 8.58388 10.0385 8.61988 10.1225C8.65588 10.2065 8.67388 10.295 8.67388 10.388C8.67388 10.484 8.65588 10.574 8.61988 10.658C8.58388 10.739 8.53438 10.8095 8.47138 10.8695C8.41138 10.9295 8.33938 10.976 8.25538 11.009C8.17138 11.045 8.08288 11.063 7.98988 11.063C7.89388 11.063 7.80388 11.045 7.71988 11.009C7.63588 10.976 7.56238 10.9295 7.49938 10.8695C7.43938 10.8095 7.39138 10.739 7.35538 10.658C7.32238 10.574 7.30588 10.484 7.30588 10.388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailAlert);
export default __webpack_public_path__ + "static/media/failAlert.0997d641f7ee95294dd389af1c95e3d4.svg";
export { ForwardRef as ReactComponent };